import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vibrationCheck",
  "use": "icon-vibrationCheck-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vibrationCheck\"><path d=\"M65.7 876.4c0 25.8 25.3 46.7 56.4 46.7h325.3l62.7-93.3h-388c-31.2 0-56.4 20.9-56.4 46.6zm835.8-37.7L588 821.2l-67.6 90.9 376.1 19.7h1.9c31.2 0 56.4-20.9 56.4-46.6 0-24.9-23.6-45.2-53.2-46.6l-.1.1zm-669.1-73.5h222.3l47-124.5h-94.1l112.9-224.4-75.2-18.7 120.6-243.8-45.4 187.7 112.9 18.7-94 187h94L577 753l244.5-37.4-37.6-336.7h75.2L671 247.9V135.6h-37.6v56.1L501.7 98.2 125.5 434.9l106.9-3.2v333.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol